import { useCallback, useMemo } from 'react'
import { generatePath, useHistory } from 'react-router-dom'
import { useIntl } from 'react-intl'

import { commonMessages } from 'app/i18n/messages'
import ROUTES from 'app/routes'
import { useAppSelector } from 'app/hooks'
import {
  // useCurrentHomeSiteId,
  useNetworkHomeJobsRouteParams,
} from 'features/networkAi/hooks'
import {
  claimDevicesFetchDataSelector,
  subsribedAccessPointsCountSelector,
} from 'features/networkAi/selectors'
import NetworkWizardLayout from '../NetworkWizardLayout'
import CreateWLANsActions from './CreateWLANsActions'
import {
  NetworkWizardCancelButton,
  NetworkWizardSubmitButton,
  NetworkWizardTitle,
} from '../styles'
import {
  StyledNetworkWizardBottomPanel,
  CreateWLANsContainer,
  CreateWLANsHeaderWrapper,
} from './styles'

function CreateWLANs() {
  const { formatMessage } = useIntl()
  const history = useHistory()

  const { rootDomainId, jobId, homeId } = useNetworkHomeJobsRouteParams()
  const claimDevices = useAppSelector(claimDevicesFetchDataSelector.data)
  const subscribedCount = useAppSelector(subsribedAccessPointsCountSelector)

  const handleBackButtonClick = useCallback(() => {
    const path = generatePath(ROUTES.networkAi.wizard.devicesList, {
      rootDomainId,
      jobId,
      homeId,
    })
    return history.push(path)
  }, [history, rootDomainId, jobId, homeId])

  const bottomBlock = useMemo(() => {
    return (
      <StyledNetworkWizardBottomPanel>
        <NetworkWizardCancelButton
          variant="secondary"
          type="button"
          onClick={handleBackButtonClick}
        >
          {formatMessage(commonMessages.back)}
        </NetworkWizardCancelButton>

        <NetworkWizardSubmitButton
          variant="primary"
          type="submit"
          disabled={true}
        >
          {formatMessage(commonMessages.next)}
        </NetworkWizardSubmitButton>
      </StyledNetworkWizardBottomPanel>
    )
  }, [handleBackButtonClick, formatMessage])

  return (
    <NetworkWizardLayout
      bottomBlock={bottomBlock}
      currentWizardStepId={4}
      hasError={subscribedCount !== claimDevices?.length}
    >
      <CreateWLANsContainer>
        <CreateWLANsHeaderWrapper>
          <NetworkWizardTitle>WLANs </NetworkWizardTitle>
        </CreateWLANsHeaderWrapper>
        <CreateWLANsActions />
      </CreateWLANsContainer>
    </NetworkWizardLayout>
  )
}

export default CreateWLANs
